/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
import * as lib from './../lib/lib'
import 'jquery-ui'

export default class DropdownsMobile {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)

    const activeDefault = 0
    const active = lib.getDataAttr(this.$element, 'active', activeDefault)

    const preview = jQuery('.b-mob-accordion__preview', this.$element)

    if (preview.length) {
      this.$element.addClass('b-mob-accordion--preview')
    }

    this.$element.accordion({
      active: active,
      collapsible: true,
      heightStyle: 'content',
      header: '.b-mob-accordion__head',
      activate: () => {
        this.togglePreview(
          preview,
          this.$element.find('.ui-accordion-header-active').length
        )
      },
      create: () => {
        this.togglePreview(
          preview,
          this.$element.find('.ui-accordion-header-active').length
        )
      },
    })
  }

  togglePreview(preview, toggle) {
    if (preview.length) {
      if (toggle) {
        preview.hide()
      } else {
        preview.show()
      }
    }
  }
}
